import React, { useState, useEffect } from 'react';
import ModalWrapper from '../../base/modals/modal-wrapper';

import { creatorWorkspaceService } from './creator-workspace-service';

import Icon from '../../ui/icon';

import './category-breakdown.scss';

const mockModuleTypes = [
  {
    name: 'New on Narrativ',
    number_available: 1,
  },
  {
    name: 'Brand Spotlight',
    number_available: 1,
  },
  {
    name: 'Offer Spotlight',
    number_available: 1,
  },
  {
    name: "Editor's Picks: Brands",
    number_available: 1,
  },
  {
    name: "Editor's Picks: Offers",
    number_available: 1,
  },
];

const ModuleModal = ({ setShowModal }) => {
  const [moduleTypes, setModuleTypes] = useState(mockModuleTypes);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const moduleTypeItems = moduleTypes.map((type, index) => {
    const selectButton =
      selectedIndex === index ? (
        <button className="selected" onClick={() => setSelectedIndex(null)}>
          <div className="text">Selected</div>
          <Icon iconName="circleCheck" size={20} />
        </button>
      ) : hoveredIndex === index ? (
        <button className="select" onClick={() => setSelectedIndex(index)}>
          Select
        </button>
      ) : null;

    return (
      <div
        className="module-type"
        key={index}
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <div>{type.name}</div>
        <div className="number-available">{type.number_available} Available</div>
        {selectButton}
      </div>
    );
  });

  return (
    <div className="module-modal" onClick={() => setShowModal(false)}>
      <ModalWrapper closeModal={() => setShowModal(null)}>
        <div className="header">Build Module</div>
        <div className="x-icon" onClick={() => setShowModal(false)}>
          <Icon iconName="x" size={12} />
        </div>
        <div className="description">
          <span>Select the type of module you’d like to build. </span>
          <i>Note: This cannot be changed later.</i>
        </div>
        <div className="module-types">{moduleTypeItems}</div>
        <hr></hr>
        <div className="buttons">
          <button className="cancel">Cancel</button>
          <button className="continue" disabled={selectedIndex === null}>
            Continue
          </button>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default ModuleModal;
